import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM17.395 9.582L11.145 15.832C10.95 16.027 10.694 16.125 10.438 16.125C10.182 16.125 9.926 16.027 9.731 15.832L6.606 12.707C6.215 12.316 6.215 11.684 6.606 11.293C6.997 10.902 7.629 10.902 8.02 11.293L10.438 13.711L15.981 8.168C16.372 7.777 17.004 7.777 17.395 8.168C17.786 8.559 17.785 9.191 17.395 9.582V9.582Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'CheckmarkFill');

export default Icon;
